import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { SvgIconEl } from 'common/components/svg-icon';
import { TooltipEl } from 'common/components/tooltip';
import { Placement } from 'common/components/tooltip/types';

function IconContainer(attrs) {
  const {
    icon
  } = attrs;
  return jsx("div", {
    sel: '.icon-container',
    attrs: {
      icon
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon
    }
  }));
}

export function template() {
  return jsx("div", {
    sel: '.mp-toggle',
    class: {
      'toggle-large': this.attr("size") === "large",
      'theme-tabbar': this.attr("theme") === "tab-bar",
      'theme-segcon': this.attr("theme") === "segmented-controller"
    }
  }, this.helpers.toggleOptions().map(toggleOption => {
    const {
      icon,
      label,
      value,
      disabled,
      tooltipLabel
    } = toggleOption;
    const hasTextAndIcon = icon && label.length;
    const isSelected = value === this.attr("selected");
    return this.attr("theme") === "segmented-controller" ? jsx("div", {
      sel: '.mp-toggle-option',
      class: {
        selected: isSelected
      }
    }, jsx(ButtonEl, {
      sel: '.mp-toggle-button',
      attrs: {
        theme: ButtonTheme.Tertiary,
        size: this.attr("size"),
        icon,
        disabled,
        selected: isSelected,
        'not-focusable': true
      },
      on: {
        click: () => !disabled && this.helpers.selectOption(value)
      }
    }, label), tooltipLabel ? jsx(TooltipEl, {
      attrs: {
        placement: Placement.Top
      }
    }, jsx("div", {
      sel: '.tooltip-content'
    }, tooltipLabel)) : null) : jsx("div", {
      sel: '.mp-toggle-option',
      class: {
        'mp-toggle-selected': value === this.attr("selected"),
        'mp-toggle-disabled': disabled,
        'mp-toggle-text-and-icon': hasTextAndIcon
      },
      on: {
        click: () => !disabled && this.helpers.selectOption(value)
      }
    }, icon ? jsx(IconContainer, {
      icon: icon
    }) : null, label, tooltipLabel ? jsx(TooltipEl, {
      attrs: {
        placement: Placement.Top
      }
    }, jsx("div", {
      sel: '.tooltip-content'
    }, tooltipLabel)) : null);
  }));
}